<p-dialog
  [style]="{ width: '320px', maxWidth: '90%' }"
  [draggable]="false"
  [modal]="true"
  [closable]="false"
  [(visible)]="alertController.loading"
>
  <app-loader message="LOADING..."></app-loader>
</p-dialog>
